import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportKpiChartsFromParams } from '@api/kpi';

import { IExportKpiFromParamsDTO } from '@interfaces/kpi/dto/kpiDTO';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { EXPORT_CHARTS_PARAMS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateExportKpiChartsFromParams = () => {
	const dispatch = useAppDispatch();

	const { mutate: exportChartsFromParams } = useMutation<IExportKpiFromParamsDTO>({
		mutationKey: [EXPORT_CHARTS_PARAMS],
		mutationFn: (data: IExportKpiFromParamsDTO) => exportKpiChartsFromParams(data),
		allowedRoles: [EUserRoles.networkOperatorKpiUpdater, EUserRoles.networkOperatorKpiViewer],
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportChartsSuccess,
				type: ESnackbarTypes.success,
			}));
		},
		onError: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportChartsError,
				type: ESnackbarTypes.error,
			}));
		},
	});

	return { exportChartsFromParams };
};
